module.exports = __webpack_public_path__ + "img/no_data.b6f3e304.png";